import { useCallback, useMemo } from 'react';
import cls from 'classnames';
import { RightOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
export default (props: Record<string, any>) => {
  const { list = [] } = props;
  const gotoLink = useCallback((item: any) => {
    console.log('gotoLink===', item);
    if (item?.redirectUrl) {
      window.open(item?.redirectUrl);
    }
  }, []);
  const brandArra = useMemo(() => {
    const brandNodes: Array<any> = [];
    let childrens: Array<any> = [];
    list.forEach((item: any, index: number) => {
      childrens.push(
        <div className={styles['production-item']} key={index}>
          <div className={cls(styles['inner-cell'])} onClick={() => gotoLink(item)}>
            <img src={item.url} />
            <div className={styles['desc-info']}>
              <p dangerouslySetInnerHTML={{ __html: item.title }}></p>
            </div>
            <a className={styles['more']}>
              <span>了解更多</span>
              <RightOutlined />
            </a>
          </div>
        </div>
      );
      if ((index + 1) % 6 == 0 || index === list.length - 1) {
        if (childrens.length) {
          brandNodes.push(
            <div key={index} className={cls(styles['production-row'], 'flex')}>
              {childrens}
            </div>
          );
        }
        childrens = [];
      }
    });
    return brandNodes;
  }, [list]);
  return <div className={styles['production-area']}>{brandArra}</div>;
};
